import PendingRequest from './PendingRequest'

export default PendingRequest


// WEBPACK FOOTER //
// ./src/components/grids/PendingRequest/index.jsx